var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.usercompany") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "d-flex flex-column", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5 pl-0",
                      attrs: { cols: "4", lg: "2", xl: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter",
                          on: {
                            click: function ($event) {
                              _vm.displayFilter = !_vm.displayFilter
                            },
                          },
                        },
                        [
                          _vm.displayFilter
                            ? _c("i", { staticClass: "fa-light fa-minus" })
                            : _c("i", { staticClass: "fa-light fa-plus" }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filter.fltr")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "4", lg: "2", xl: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter",
                          attrs: { disabled: _vm.activateSpinner },
                          on: {
                            click: function ($event) {
                              return _vm.onRefresh()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-rotate-right fs-14px",
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "4", lg: "3", xl: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.exportUserCompany()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-upload" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "fab-label" }, [
                            _vm._v(_vm._s(_vm.$t("common.extract"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-5",
                      attrs: { cols: "6", lg: "3", xl: "3" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: !_vm.canAddUser,
                          },
                          on: { click: _vm.addUser },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-plus" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("administration.user_add"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.displayFilter
                ? _c(
                    "b-row",
                    { staticClass: "justify-content-start" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "filter-item-action mb-5 pl-0",
                          attrs: { sm: "6", lg: "3", cols: "12" },
                        },
                        [
                          _c("span", { staticClass: "filter-item-title" }, [
                            _vm._v(_vm._s(_vm.$t("administration.identifier"))),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-item-content" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.login,
                                  expression: "login",
                                },
                              ],
                              class: {
                                "filter-item-input": true,
                                "filter-item-input-complete": _vm.login,
                              },
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t(
                                  "administration.identifier"
                                ),
                              },
                              domProps: { value: _vm.login },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.login = $event.target.value
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "filter-item-action mb-5",
                          attrs: { sm: "6", lg: "3", cols: "12" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "filter-item-title",
                              attrs: { for: "name-company" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_name"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.nameCompany,
                                  expression: "nameCompany",
                                },
                              ],
                              staticClass: "filter-item-content min-w-100",
                              staticStyle: {
                                "max-width": "100%",
                                padding: "0.5rem",
                              },
                              attrs: { id: "select-name-company" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.nameCompany = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("administration.select_company")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.allCompanies,
                                function (company, index) {
                                  return _c(
                                    "option",
                                    {
                                      key:
                                        "filtered-profile-" +
                                        company.name +
                                        "-" +
                                        index,
                                      domProps: { value: company.name },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(company.name) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "filter-item-action mb-5",
                          attrs: { sm: "6", lg: "3", cols: "8" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "filter-item-title",
                              attrs: { for: "user-active" },
                            },
                            [_vm._v(_vm._s(_vm.$t("administration.active")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userActive,
                                  expression: "userActive",
                                },
                              ],
                              ref: "selectDoctype",
                              staticClass: "filter-item-content min-w-100",
                              staticStyle: {
                                "max-width": "100%",
                                padding: "0.5rem",
                              },
                              attrs: { id: "select-user-active" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.userActive = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("administration.select_activity")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "0" } }, [
                                _vm._v(_vm._s(_vm.$t("administration.no"))),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "1" } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("administration.in_prgrss"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "2" } }, [
                                _vm._v(_vm._s(_vm.$t("administration.yes"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex flex-row-reverse mt-4 pr-0 pb-5",
                          attrs: { lg: "3", cols: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.applyFilter()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("common.srch")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-3",
                              attrs: {
                                size: "sm",
                                disabled: !_vm.hasInputFilter,
                              },
                              on: { click: _vm.clearFilterFields },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("filter.clr_fltr_field")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "p-0" },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.UsersList.length > 0
                        ? _c("b-table", {
                            staticClass: "table table-striped",
                            attrs: {
                              responsive: "",
                              hover: "",
                              fields: _vm.fields,
                              items: _vm.UsersList,
                              selectable: _vm.UsersList.length > 0,
                              "empty-text": _vm.$t("common.security.no_result"),
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDir,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "head-clicked": _vm.sortTable,
                              "row-selected": _vm.seeUserDetails,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(Active)",
                                fn: function (data) {
                                  return [
                                    data.value === "0"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-light fa-xmark btn btn-icon btn-icon-red",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.value === "2"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-light fa-check btn btn-icon btn-icon-green",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.value === "1"
                                      ? _c("i", {
                                          staticClass:
                                            "fa-light fa-warning btn btn-icon btn-icon-orange",
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(Account)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          data.item.Rights[0].AccountName
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(delete)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-4 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.activateDelete(
                                              $event,
                                              data.value
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-light fa-trash",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(data.value.IdUser)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-5" },
                [
                  _c(
                    "b-col",
                    [
                      _c("cm-pagination", {
                        attrs: {
                          maxResultsByPage: _vm.paginationObject.maxResults,
                          firstIndex: _vm.paginationObject.firstIndex,
                          nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                          refreshEvent: _vm.paginationObject.refresh,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }